import memoize from 'memoize-one';
import { uniq, first, pick } from 'lodash';
import moment from 'moment';
// import messages from './onlineSimulatedMessages';

export const paginate = memoize((array, page, limit) =>
  array.slice((page - 1) * limit, page * limit),
);

export const filterEvaluations = memoize((evaluations, year) =>
  evaluations.filter((evaluation) => {
    const matchYear = year === moment(evaluation.dateStart).year();
    return matchYear;
  }),
);

export const getYears = (evaluations = []) => {
  if (!evaluations.length) return [];
  const years = uniq(
    evaluations
      .map((e) => moment(e.dateStart || new Date()).year())
      .sort()
      .reverse(),
  );
  return years;
  // return uniqBy(
  //   evaluations
  //     .map((e) => moment(Date.parse(e.dateStart) || new Date()).year())
  //     .sort()
  //     .reverse(),
  // );
};

export const getEvaluationsOnline = (evaluations = []) =>
  evaluations.map((e) => ({
    ...e,
    applicationDisciplines: e.disciplines.map((c) => c).join(' | '),
    abbreviationsDisciplines: e.abbreviations.map((c) => c).join(' | '),
  }));

// export const colors = ['#FF836A', '#FFAF2E', '#BEE94B', '#59E6AA', '#0DD396', '#B5B5B5'];
